export const SITE = 'rca';

export const extractAgents = (agencies) =>
  agencies.reduce((agentList, agency) => {
    if (agency.salespeople) {
      agency.salespeople.forEach(({ id }) =>
        agentList.push({ agent_id: id, agency_id: agency.id }),
      );
    } else {
      agentList.push({ agency_id: agency.id });
    }
    return agentList;
  }, []);

export const extractAgentIds = (agencies) =>
  agencies.reduce((agentList, agency) => {
    agency.salespeople.forEach(({ id }) => agentList.push({ agent_id: id }));
    return agentList;
  }, []);

export const extractSecondaryValues = (sourceList = [], key) =>
  sourceList.slice(1).map((item) => (key ? item[key] : item));

export const extractSortBy = (activeSort) => {
  const sortBytrans = {
    'price-desc': 'price-high-to-low',
    'price-asc': 'price-low-to-high',
    'date-desc': 'date-new-to-old',
    'date-asc': 'date-old-to-new',
    'tenancy.netIncome-desc': 'income-high-to-low',
    'tenancy.netIncome-asc': 'income-low-to-high',
    'tenancy.numberOfTenants-asc': 'tenancy-low-to-high',
    'tenancy.numberOfTenants-desc': 'tenancy-high-to-low',
    'calculatedYield-desc': 'yield-high-to-low',
    'calculatedYield-asc': 'yield-low-to-high',
  };
  return sortBytrans[activeSort] || 'relevance';
};

export const extractKeywordsData = (keywords) =>
  keywords
    ?.replace(' ', '')
    .split(',')
    .filter((keyword) => keyword.length > 0);

const formatLocalities = (localities) =>
  localities?.map((locality) =>
    `${locality.locality}, ${locality.subdivision || ''} ${locality.postcode || ''}`.replace(
      /[^A-Za-z0-9]+$/,
      '',
    ),
  );

const formatBoundingBox = ({
  northEastLatitude,
  northEastLongitude,
  southWestLatitude,
  southWestLongitude,
}) => [`${northEastLatitude},${northEastLongitude},${southWestLatitude},${southWestLongitude}`];

export const extractLocationsRequested = (localities, boundingBox) => {
  if (boundingBox) {
    return formatBoundingBox(boundingBox);
  }

  return formatLocalities(localities);
};

const enumArr = ['state', 'region', 'suburb', 'postal_code', 'address', 'street'];
const translatePrecision = (precision) =>
  enumArr.indexOf(precision) > -1 && (precision === 'postal_code' ? 'postcode' : precision);

export const extractLocalities = (resolvedLocations) => {
  if (resolvedLocations.length > 0) {
    const localities = [];
    resolvedLocations.forEach((resolvedLocation) => {
      const precision = translatePrecision(resolvedLocation.precision?.toLowerCase());
      if (precision) {
        localities.push({
          display: resolvedLocation.location,
          precision,
          state: resolvedLocation.state,
        });
      }
    });
    return localities.length > 0 ? localities : undefined;
  }
};

export const extractSearchResultsListingProps = (listings) =>
  listings.map(({ id, product }) => ({
    id,
    product_depth: product,
    is_project: false,
  }));

export const extarctAttributeValue = (attributes, key) =>
  attributes.find(({ id }) => id === key)?.value;

export const extractCarSpaces = (attributes) => {
  const carSpaces = extarctAttributeValue(attributes, 'car-spaces');
  return carSpaces ? parseInt(carSpaces, 10) : undefined;
};
